import { Phone, MessageCircle } from "lucide-react";
import { TEL_HREF, WA_HREF } from "../../lib/business";

export const StickyMobileCTA = () => {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#E5E5E5] shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.12)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
    >
      <div className="flex items-stretch gap-0">
        <a
          data-testid="sticky-call"
          href={TEL_HREF}
          className="flex-1 inline-flex items-center justify-center gap-2 h-14 text-sm font-semibold tracking-wider text-[#1A1A1A] border-r border-[#E5E5E5]"
        >
          <Phone className="w-4 h-4 text-[#D4AF37]" /> Call
        </a>
        <a
          data-testid="sticky-whatsapp"
          href={WA_HREF}
          target="_blank"
          rel="noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 h-14 text-sm font-semibold tracking-wider btn-gold"
        >
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </a>
      </div>
    </div>
  );
};
